import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const DisclaimerMessageTable = ({
    domains,
    setSelectedDisclaimer,
    setSelectedDisclaimerName,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    previewOnClick={previewOnClick}
                    id={item.coBrandId}
                    item={item}
                    deleteOnClick={deleteOnClick}
                />
            ),
        },
        {
            name: 'Cobrand',
            fieldName: 'cobrandName',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Disclaimer Message',
            fieldName: 'disclaimerMessage',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = domains ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedDisclaimer(selectedItem && selectedItem.coBrandId);
        setSelectedDisclaimerName?.(selectedItem?.cobrandName || "");
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Disclaimer Message"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About the Disclaimer Message"
                summary="This table displays all disclaimer messages for cobrands, including the cobrand name and the message itself. You can add, edit, or delete. This feature allows cobrands to display custom text to users throughout the platform and is found in the footer of most pages."
                imageUrlPath='disclaimer-message'
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.cobrandName || item?.disclaimerMessage || item?.name || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default DisclaimerMessageTable;
